export enum HealthCheckHttpPaths {
  healthCheck = '/api/v1.0/health-check',
}
